export const UnorderedListLineHeight = {
  SMALL: 'small',
  MEDIUM: 'body'
};